export const delay = (function() {
    var timer = 0;
    return function(callback, ms) {
        clearTimeout(timer);
        timer = setTimeout(function() { callback(); }, ms);
    };
})();


// WEBPACK FOOTER //
// ./src/helpers/delay.js